
import * as ipxRuntime$n6OyCNsWuIv2YGIIwLOlaw0Im9y47AVA3_d_OXb5OKQ from '/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$n6OyCNsWuIv2YGIIwLOlaw0Im9y47AVA3_d_OXb5OKQ, defaults: {} }
}
        